// extracted by mini-css-extract-plugin
export default {"select":"index_select__Jzwk-"};